import * as amplify from "../../util/amplify.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import { markValidNative, markInvalidNative } from "../../util/forms.ts";
import ApiServer from "../../ApiServer.ts";
import * as i18n from "../../i18n.ts";
import {getCache} from "../../server/objects/BudgetBeans.ts";
import MAIN_MODAL from "../../budget/modal_categories.mustache";
import MAIN_MODAL_HIDDEN from "../../budget/modal_categories_hidden.mustache";
import TPL_ITEM from "../../budget/modal_categories_item.mustache";
import { registerDragStart } from "../../lib/FileUtils.ts";

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();


Html.registerDom({
  budgetcategoryuiadd(){
    const theModal = this.closest('.modal') as HTMLElement;
    if(!theModal) return;

    const typeInput = theModal.querySelector('[name=budgetTransactionType]') as HTMLInputElement;
    const budgetTransactionType = typeInput?.value;
    const goodGroup = theModal.querySelector('[data-transaction-type='+budgetTransactionType+']') as HTMLElement;
    if(!goodGroup) return;

    const catNode = Html.setHtmlAtEndDom(goodGroup,TPL_ITEM,{emoji:'💰',rights:{canUpdate:true,canDelete:true}})
    const nameInput = catNode.querySelector('input[name=name]') as HTMLInputElement;
    if(nameInput) nameInput.focus();
  },
  budgetcategoryuihidden(){
    const theModal = this.closest('.modal') as HTMLElement;
    if(!theModal) return;

    const typeInput = theModal.querySelector('[name=budgetTransactionType]') as HTMLInputElement;
    const openType = typeInput?.value;
    const hiddenCategories = budgetCategoryCache.hidden();

    modal.closeDomModal();
    const theModalHidden = modal.openDomModal(MAIN_MODAL_HIDDEN,{
      budgetTransactionType:openType,
      isEmpty:hiddenCategories.length===0,
      EXPENSE:hiddenCategories.filter(cat=>cat.budgetTransactionType==='EXPENSE'),
      REVENUE:hiddenCategories.filter(cat=>cat.budgetTransactionType==='REVENUE')
    });

    const budgetTransactionType = theModalHidden.querySelector('[name=budgetTransactionType]') as HTMLInputElement;

    const icons = theModalHidden.querySelectorAll("flexrow>icon");
    icons.forEach(icon => {
      icon.addEventListener('click', function(){
        const metaIdNode = Html.getDomMetaIdNode(this);
        const metaId = Html.getDomMetaId(metaIdNode);
        const category = budgetCategoryCache.get(metaId);

        category.hidden = false;
        ApiServer.budgetcategoryput(category,function(){
          const visibleNodes = theModalHidden.querySelectorAll('[data-fw-meta-id]:not([style*="display: none"])');
          if(visibleNodes.length > 1){
            metaIdNode.style.display = 'none';
          }else{
            metaIdNode.remove();
            const emptyEl = theModalHidden.querySelector('.empty') as HTMLElement;
            if(emptyEl) emptyEl.style.display = '';
          }
        })
        budgetCategoryCache.refresh()
      });
    });

    theModalHidden.onClose = function(){
      Html.trigger(null,"budgetcategorymanage")
    }

    function updateUI(){
      const currentType = budgetTransactionType?.value;
      const transactionTypeNodes = theModalHidden.querySelectorAll<HTMLElement>('[data-transaction-type]');
      transactionTypeNodes.forEach((node: HTMLElement) => {
        const nodeType = node.getAttribute('data-transaction-type');
        node.style.display = nodeType === currentType ? '' : 'none';
      });

      const metaIdNodes = theModalHidden.querySelectorAll(`[data-transaction-type="${currentType}"] [data-fw-meta-id]`);
      const emptyEl = theModalHidden.querySelector('.empty') as HTMLElement;
      if(emptyEl) {
        emptyEl.style.display = metaIdNodes.length === 0 ? '' : 'none';
      }
    }
    updateUI();

    theModalHidden.addEventListener('change', function(evt){
      const target = evt.target as HTMLElement;
      if(target.tagName === 'INPUT') {
        updateUI();
      }
    });
  },

  budgetcategorymanage(type){
    let modified = false;

    const theModal = modal.openDomModal(MAIN_MODAL,{
      budgetTransactionType:type==='REVENUE'?'REVENUE':'EXPENSE',
      EXPENSE:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='EXPENSE'),
      REVENUE:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='REVENUE')
    })

    const budgetTransactionType = theModal.querySelector('[name=budgetTransactionType]') as HTMLInputElement;

    function updateUI(){
      const currentType = budgetTransactionType?.value;
      const transactionTypeNodes = theModal.querySelectorAll<HTMLElement>('[data-transaction-type]');
      transactionTypeNodes.forEach((node: HTMLElement) => {
        const nodeType = node.getAttribute('data-transaction-type');
        node.style.display = nodeType === currentType ? '' : 'none';
      });
    }
    updateUI();

    const inputs = theModal.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('keypress', function(ev){
        if(ev.keyCode===13 || ev.keyCode===10){
          ev.preventDefault();
          this.blur();
        }
      });
    });

    theModal.onClose = function(){
      if(modified){
        amplify.publish('budgetNeedRefresh')
      }
    }

    theModal.addEventListener('change', Html.createDelegateListener('input', function(evt, target){
      const inputTarget = target as HTMLInputElement;

      if(inputTarget.name!=='emoji' && inputTarget.name!=='name') {
        updateUI();
        return;
      }

      const catnode = target.closest('flexrow') as HTMLElement;
      if(!catnode) return;

      const nameInput = catnode.querySelector('[name=name]') as HTMLInputElement;
      const emojiInput = catnode.querySelector('[name=emoji]') as HTMLInputElement;
      const name = nameInput?.value;
      const emoji = emojiInput?.value;

      if(!name){
        markInvalidNative(catnode, i18n.get('budget.categoryerrors.noname'));
        const firstInput = catnode.querySelector('input') as HTMLInputElement;
        if(firstInput) firstInput.focus();
        return;
      }

      const metaId = Html.getDomMetaId(catnode);
      const currentType = budgetTransactionType?.value;

      ApiServer.budgetcategoryput({metaId, emoji, name, budgetTransactionType:currentType},function(newCat){
        modified = true;
        const newNode = Html.replaceWithSingleDom(catnode,TPL_ITEM,newCat);
        markValidNative(newNode);
      },function(err){
        if(err.code==='63'){
          markInvalidNative(catnode, i18n.get('budget.categoryerrors.63'));
          const firstInput = catnode.querySelector('input') as HTMLInputElement;
          if(firstInput) firstInput.focus();
        }else{
          throw err;
        }
      })
    }));

    theModal.addEventListener('click', Html.createDelegateListener('flexrow>icon[data-type="delete"]', function(evt, target){
      const catnode = target.closest('flexrow') as HTMLElement;
      if(!catnode) return;

      const metaId = Html.getDomMetaId(catnode);
      markValidNative(catnode);

      if(!metaId){
        catnode.style.display = 'none';
      } else{
        ApiServer.budgetcategoryput({metaId, hidden:true},function(){
          modified = true;
          catnode.style.display = 'none';
        })
        budgetCategoryCache.refresh()
      }
    }));
  }
})

registerDragStart(".budgetcategorylist>*",async function(ev,dropPromiseBuilder){
  const movingNode = this;
  const potentialDrop = Array.from(document.querySelectorAll<HTMLElement>('.budgetcategorylist>*'));
  const dropEvent = await dropPromiseBuilder(this,potentialDrop);
  const dropNode = Html.getDomMetaIdNode(dropEvent.target as HTMLElement);

  let nodeBefore: HTMLElement | null = null;
  const dropRect = dropNode.getBoundingClientRect();
  if(dropRect.top + dropRect.height/2 > dropEvent.clientY){
    nodeBefore = dropNode.previousElementSibling as HTMLElement;
    dropNode.parentElement?.insertBefore(movingNode, dropNode);
  }else{
    nodeBefore = dropNode;
    if(dropNode.nextElementSibling){
      dropNode.parentElement?.insertBefore(movingNode, dropNode.nextElementSibling);
    }else{
      dropNode.parentElement?.appendChild(movingNode);
    }
  }

  const movingMetaId = Html.getDomMetaId(movingNode);
  const beforeMetaId = nodeBefore ? Html.getDomMetaId(nodeBefore) : null;
  ApiServer.budgetcategoryput({metaId:movingMetaId, prevId:beforeMetaId||"$empty"},function(){})
  amplify.publish('budgetNeedRefresh');

})
